
import { Options, Vue }    from 'vue-class-component';
import { mapGetters, mapActions } from 'vuex';
import { config } from '@/config';
import { salesqueze } from './libs/salesqueze-sdk-browser';
import Switcher from './components/shared/switcher.vue'

@Options({
  components: {
    Switcher
  },
  computed: mapGetters(['getFooterContent', 'getSteps', 'getCurrentItem', 'getPartnerData', 'getIsCartPriceable', 'getProducts', 'getLang']),
  methods: mapActions(['setFooterContent', 'setTotalSteps', 'setCurrentStep', 'unsetCurrentItem', 'setPartnerData', 'updateCartProducts', 'setForm', 'setLang']),
  name: 'App',
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || 'Vez Sedeži'
        let queryChange = false;
        let query = Object.assign({}, to.query);

        if (to.query && to.query.partnerKey) {
          this.$store.state.partnerKey = to.query.partnerKey as string;
          sessionStorage.setItem('partnerKey', this.$store.state.partnerKey)
        } else if (sessionStorage.getItem('partnerKey')) {
          this.$store.state.partnerKey = sessionStorage.getItem('partnerKey');
        }
        if (to.query && to.query.lang) {
          if (to.query.lang !== this.getLang) {
            this.setLang(to.query.lang);
            this.$i18n.locale = to.query.lang;
          }
          delete query.lang;
          queryChange = true;
        }
        if ((!from || (from.query && !from.query.documentId && !from.query.edit_token)) && to.query && to.query.documentId && to.query.edit_token) {
          this.handleEditData(to.query.documentId as string, to.query.edit_token as string);
        }
        if (queryChange) {
          this.$router.replace({
            path: to.path,
            query: query,
          });
        }
      }
    }
  }
})
export default class Dev extends Vue {
  getFooterContent!: any;

  logoUrl = `https://salesqueze-production-fs.s3.eu-central-1.amazonaws.com/${config.clientKey}/assets/logo.png`
  declare setPartnerData: (data: any) => void;
  declare getPartnerData: any;
  declare getIsCartPriceable: boolean;
  declare getProducts: any[];
  declare updateCartProducts: (data: any) => void;
  declare setForm: (data: any) => void;
  declare getLang: string;

  async mounted(): Promise<void> {
    (this as any).setTotalSteps(this.steps.length);
    await this.handlePartnerData();
    // await this.handleEditData();
  }

  async handlePartnerData(): Promise<void> {
    
    if (this.$store.state.partnerKey) {
      const partnerInfo = await salesqueze.getPartnerInfo(this.$store.state.partnerKey);
      this.setPartnerData(partnerInfo.data);
    }
  }

  async handleEditData(documentId: string, editToken: string): Promise<void> {
    this.$store.state.loadingEdit = true;
    try {
      const order = await salesqueze.getOrder(documentId, editToken);
      this.updateCartProducts(order?.data?.cpq?.cart?.products.map((val: any) => {
        val.key = val.catalogKey;
        val.configurableAddons = val.configurableAddons.map((addon: any) => {
          addon.products = addon.products.map((prod: any) => {
            prod.key = prod.catalogKey;
            return prod;
          });
          return addon;
        })
        return val;
      }));
      this.setForm(order?.data?.form || {});
    } catch(e) {
      // do nothing
    } finally {
      this.$store.state.loadingEdit = false;
    }

  }

  async handleClickNext(): Promise<void> {
    if (this.getFooterContent.next.to) {
      this.$router.push(this.getFooterContent.next.to)
    } else if (this.getFooterContent.next.action) {
      await this.getFooterContent.next.action();
    }
  }

  async handleClickBack(): Promise<void> {
    if (this.getFooterContent.back.to) {
      this.$router.push(this.getFooterContent.back.to)
    } else if (this.getFooterContent.back.action) {
      await this.getFooterContent.back.action();
    } else if (!(this as any).getCurrentItem.key) {
      this.$router.push(this.steps[0].to);
    } else if ((this as any).getSteps.step) {
      this.$router.push(this.steps[(this as any).getSteps.step - 2].to);
    } else {
      this.$router.back();
    }
  }

  navigate(step: string): void {
    const stepEntry: any = this.steps.find((elem: any) => elem.step === step)
    if (stepEntry && step < (this as any).getSteps.step){
      this.$router.push(stepEntry.to)
    }
  }

  navigateModel(): void {
    (this as any).unsetCurrentItem();
    this.$router.push('/shop/model');
  }

  get steps(): any[] {
    return [
    {
      title: this.$t('nav.model'),
      step: 1,
      to: '/shop/model'
    },
    {
      title: this.$t('nav.details'),
      step: 2,
      to: '/shop/details'
    },
    {
      title: this.$t('nav.summary'),
      step: 3,
      to: '/shop/summary'
    },
    {
      title: this.$t('nav.preview'),
      step: 4,
      to: '/shop/preview'
    },
  ]
  }
}
